import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useMemo, useCallback, useLayoutEffect, useEffect } from 'react';
import debounce from '../node_modules/lodash.debounce/index.js';

var defaultState = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0
};
function useRect() {
  var debounceTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    element = _useState2[0],
    setElement = _useState2[1];
  var _useState3 = useState(defaultState),
    _useState4 = _slicedToArray(_useState3, 2),
    rect = _useState4[0],
    setRect = _useState4[1];
  var debouncedSetRect = useMemo(function () {
    return debounce(setRect, debounceTime);
  }, [debounceTime]);
  var update = useCallback(function () {
    if (element) {
      debouncedSetRect(element.getBoundingClientRect());
    }
  }, [element]);
  var observer = useMemo(function () {
    return element && new ResizeObserver(function (entries) {
      var _entries = _slicedToArray(entries, 1),
        entry = _entries[0];
      if (entry) {
        update();
      }
    });
  }, [debouncedSetRect, element]);
  useLayoutEffect(function () {
    if (element && observer) observer.observe(element);
    return function () {
      if (observer) observer.disconnect();
      debouncedSetRect.cancel();
    };
  }, [element, observer]);
  useEffect(function () {
    window.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return function () {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [update]);
  useLayoutEffect(function () {
    update();
  }, [].concat(_toConsumableArray(dependencies), [update]));
  var ref = useMemo(function () {
    return function (node) {
      return setElement(node);
    };
  }, []);
  return [ref, rect];
}

export { useRect as default };
//# sourceMappingURL=useRect.js.map
